/**
 * Session timeout warning and auto-logout.
 *
 * Monitors the user's session duration client-side and displays a countdown
 * modal before automatically signing out. Syncs across tabs via broadcast.
 */
import initSessionInformer from '../lib/session_informer';

initSessionInformer();
